'use client'
import { SDKApi, Configuration } from '@dynamic-labs/sdk-api-core';
import { FetchService } from '@dynamic-labs/utils';
import { VERSION, API_VERSION } from '../../../version.js';
import ApiEndpoint from '../../config/ApiEndpoint.js';
import '../../utils/constants/values.js';
import '../../../../_virtual/_tslib.js';
import '@dynamic-labs/multi-wallet';
import '../../shared/logger.js';
import '../../utils/constants/colors.js';
import { getMinAuthToken } from '../../utils/functions/getMinAuthToken/getMinAuthToken.js';
import 'react-international-phone';
import '@dynamic-labs/iconic';
import '@dynamic-labs/wallet-connector-core';
import 'react/jsx-runtime';
import '../../context/ViewContext/ViewContext.js';
import 'react';
import '@dynamic-labs/wallet-book';
import '../../store/state/loadingAndLifecycle.js';
import '../../shared/consts/index.js';
import '../../store/state/user/user.js';
import '../../locale/locale.js';
import { isCookieEnabled } from '../../utils/functions/isCookieEnabled/isCookieEnabled.js';

const sdkApi = ({ customHeaders } = {}) => {
    const settings = {
        basePath: ApiEndpoint.getBaseUrl(),
        headers: Object.assign({ 'Content-Type': 'application/json' }, customHeaders),
    };
    const minJwt = getMinAuthToken();
    if (minJwt) {
        settings.headers.Authorization = `Bearer ${minJwt}`;
    }
    const credentials = isCookieEnabled()
        ? 'include'
        : undefined;
    settings.headers['x-dyn-version'] = `WalletKit/${VERSION}`;
    settings.headers['x-dyn-api-version'] = `API/${API_VERSION}`;
    return new SDKApi(new Configuration(Object.assign(Object.assign({}, settings), { credentials, fetchApi: FetchService.fetch })));
};

export { sdkApi };
